import { useEffect, useState } from "react"
import AwardInterface from "../../../interfaces/Award.interface"
import { getAwardService } from "../../../services/awards.services"
import { Link, useParams } from "react-router-dom"
import { toast } from "react-toastify"
import Loader from "../../../components/Loader"
import { useAppSelector } from "../../../store/store"
import Modal from "../../../components/Modal"
import InputText from "../../../components/InputText"
import TextArea from "../../../components/TextArea"
import Button from "../../../components/Button"
import EditForm from "./EditForm"
import Content from "../../../components/Content"

const AwardOverviewPage = () => {
    const { awardId } = useParams()

    const player = useAppSelector(state => state.player)

    const [award, setAward] = useState<AwardInterface | null>(null)
    const [players, setPlayers] = useState<{ id: string, name: string, quantity: number }[]>([])
    const [requesting, setRequesting] = useState<boolean>(true)

    useEffect(() => {
        getAwardService(awardId || "")
            .then((res) => {
                setAward(res.data.payload.award)
                setPlayers(res.data.payload.players)
            })
            .catch((error) => toast.error(error.response.data.message))
            .finally(() => setRequesting(false))
    }, [awardId])

    if (requesting && !award) return <Loader />

    if (!requesting && !award) return (
        <div className="flex justify-center p-10 items-center">
            <p className="text-zinc-500">Premio no encontrado</p>
        </div>
    )

    return (
        <Content className="flex flex-col gap-5">
            <div className="flex flex-col-reverse items-center md:flex-row md:justify-between gap-5 border-b pb-5">
                <div className="flex flex-col gap-5">
                    <p className="text-zinc-700 font-semibold text-2xl text-center md:text-left">{award?.name}</p>
                    <p className="text-zinc-500 text-center md:text-left">{award?.description}</p>
                    {player.admin && <EditForm award={award as AwardInterface} onUpdated={(award) => setAward(award)} />}
                </div>
                <div className="h-[100px] w-[100px] min-h-[100px] min-w-[100px] flex items-center justify-center rounded bg-gray-200 text-3xl">?</div>
            </div>
            <p className="text-zinc-500 text-xl">Ganadores</p>
            <table className="w-full text-sm text-left rtl:text-right text-gray-500 ">
                <thead className="text-xs text-gray-700 uppercase bg-gray-50">
                    <tr>
                        <th scope="col" className="gap-2 px-6 py-3">
                            Jugador
                        </th>
                        <th scope="col" className="px-6 py-3">
                            Cantidad
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {players.length > 0 ?
                        players.map(player => (
                            <tr key={player.id as string} className="bg-white border-b">
                                <td className="flex items-center gap-5 px-6 py-4 font-medium text-gray-900 whitespace-nowrap">
                                    <Link to={`/p/${player?.name}`}>{player?.name}</Link>
                                </td>
                                <td className="px-6 py-4">
                                    <p className="text-zinc-700 font-bold">{player.quantity}</p>
                                </td>
                            </tr>
                        ))
                        : <p className="italic text-zinc-500">Aún ningún jugador ganó este premio.</p>}
                </tbody>
            </table>
        </Content>
    )
}

export default AwardOverviewPage